module.exports = __webpack_public_path__ + "assets/bd18d0dcb67c7c92e6bceee05ce87866.png";